import type { AddBusinessCustomerV2FormData } from './types'

type TranslationFn = (key: string) => string

export type ConfirmItem = { id: string; title: string; body: string }

export const getConfirmItems = (
  t: TranslationFn,
  data: AddBusinessCustomerV2FormData,
  displayData: Partial<AddBusinessCustomerV2FormData>
): ConfirmItem[] => {
  const showOperationalAddress = data.isOperationalAddressDifferent === 'true'

  return [
    { id: 'name', title: t('customers.businessName'), body: data.name },
    {
      id: 'entityType',
      title: t('manageBeneficiaries.entityType'),
      body: displayData.entityType || data.entityType,
    },
    { id: 'useCase', title: t('customers.useCase'), body: displayData.useCase || data.useCase },
    {
      id: 'registrationNumber',
      title: t('customers.registrationNumber'),
      body: data.registrationNumber,
    },
    { id: 'taxNumber', title: t('customers.taxIdentification'), body: data.taxNumber },
    {
      id: 'taxResidenceCountryCode',
      title: t('customers.taxResidency'),
      body: displayData.taxResidenceCountryCode || data.taxResidenceCountryCode,
    },
    { id: 'naicsCode', title: t('customers.naicsCode'), body: data.naicsCode },
    {
      id: 'monthlyExpectedVolumes',
      title: t('customers.monthlyVolumes'),
      body: displayData.monthlyExpectedVolumes || data.monthlyExpectedVolumes,
    },
    {
      id: 'isRegulated',
      title: t('embeddedCustomers.businessForm.isRegulated'),
      body: displayData.isRegulated || data.isRegulated,
    },
    {
      id: 'sourceOfFunds',
      title: t('customers.sourceOfFunds'),
      body: displayData.sourceOfFunds || data.sourceOfFunds,
    },
    {
      id: 'intendedUseOfAccount',
      title: t('customers.intendedUse'),
      body: displayData.intendedUseOfAccount || data.intendedUseOfAccount,
    },
    {
      id: 'registeredAddressLine1',
      title: t('customers.address.addressLine1'),
      body: data.registeredAddressLine1,
    },
    {
      id: 'registeredAddressCity',
      title: t('customers.address.city'),
      body: data.registeredAddressCity,
    },
    {
      id: 'registeredAddressPostalCode',
      title: t('customers.address.postalCode'),
      body: data.registeredAddressPostalCode,
    },
    {
      id: 'registeredAddressCountryCode',
      title: t('customers.address.country'),
      body: displayData.registeredAddressCountryCode || data.registeredAddressCountryCode,
    },
    {
      id: 'isOperationalAddressDifferent',
      title: t('customers.isOperationalAddressDifferent'),
      body: displayData.isOperationalAddressDifferent || data.isOperationalAddressDifferent,
    },
    ...(showOperationalAddress
      ? [
          {
            id: 'operationalAddressLine1',
            title: t('customers.address.addressLine1'),
            body: data.operationalAddressLine1,
          },
          {
            id: 'operationalAddressCity',
            title: t('customers.address.city'),
            body: data.operationalAddressCity,
          },
          {
            id: 'operationalAddressPostalCode',
            title: t('customers.address.postalCode'),
            body: data.operationalAddressPostalCode,
          },
          {
            id: 'operationalAddressCountryCode',
            title: t('customers.address.country'),
            body: displayData.operationalAddressCountryCode || data.operationalAddressCountryCode,
          },
        ]
      : []),
  ]
}
